/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ResponseEnterpriseGetListMeta
 */
export interface ResponseEnterpriseGetListMeta {
  /**
   *
   * @type {number}
   * @memberof ResponseEnterpriseGetListMeta
   */
  limit?: number
  /**
   *
   * @type {number}
   * @memberof ResponseEnterpriseGetListMeta
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof ResponseEnterpriseGetListMeta
   */
  total?: number
}

/**
 * Check if a given object implements the ResponseEnterpriseGetListMeta interface.
 */
export function instanceOfResponseEnterpriseGetListMeta(
  value: object,
): value is ResponseEnterpriseGetListMeta {
  return true
}

export function ResponseEnterpriseGetListMetaFromJSON(
  json: any,
): ResponseEnterpriseGetListMeta {
  return ResponseEnterpriseGetListMetaFromJSONTyped(json, false)
}

export function ResponseEnterpriseGetListMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnterpriseGetListMeta {
  if (json == null) {
    return json
  }
  return {
    limit: json['limit'] == null ? undefined : json['limit'],
    offset: json['offset'] == null ? undefined : json['offset'],
    total: json['total'] == null ? undefined : json['total'],
  }
}

export function ResponseEnterpriseGetListMetaToJSON(
  json: any,
): ResponseEnterpriseGetListMeta {
  return ResponseEnterpriseGetListMetaToJSONTyped(json, false)
}

export function ResponseEnterpriseGetListMetaToJSONTyped(
  value?: ResponseEnterpriseGetListMeta | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    limit: value['limit'],
    offset: value['offset'],
    total: value['total'],
  }
}
